module.exports = __webpack_public_path__ + "static/img/ic_video_stop.849dd6c5.png";